import { startOfDay } from 'date-fns';

import { AppointmentStatusType } from '../../graphql';
import { convertStringToDate } from '../date/convert-string-to-date';

export const isAppointmentActual = (date: string): boolean => (
  convertStringToDate(date)!.valueOf() - startOfDay(new Date()).valueOf() >= 0
);

export const isAppointmentStatusGood = (status: string): boolean => (
  status === AppointmentStatusType.confirmed || status === AppointmentStatusType.unconfirmed
);

export const isAppointmentContentShow = (date?: string, status?: string): boolean => {
  if (!date || !status) {
    return false;
  }

  return isAppointmentActual(date) && isAppointmentStatusGood(status);
};
